import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { NgbCalendar, NgbDate, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { IconsService } from 'src/app/shared/services/icons.service';
import { FullFilterComponent } from 'src/app/components/offcanvas/full-filter.component';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { lastMonthDay } from 'src/app/shared/utils/utils';

@Component({
  selector: 'app-invoice-dashboard',
  template: `
    <div class="d-flex mb-4 mt-4">
      <div class="flex-fill">
        <h1>Facturación</h1>
      </div>
      <div class="ms-auto text-end">
      <!-- button class="btn btn-outline-primary btn-lg rounded-5 shadow border border-3 border-primary" routerLink="/condominios/create/condominio">
      <fa-icon [icon]="faPlus" class="me-2"></fa-icon>
        Agregar
      </!-->
        <!-- button class="btn btn-primary btn-lg rounded-5 ms-3" routerLink="/bills/new">Crear recibo</!-->

        <div class="flex-fill text-end mt-2">
          <div class="float-end">
            <!-- div class="btn-group border border-1 border-secondary me-2" role="group" aria-label="Basic example">
              <button id="btnList" #btnList type="button" class="btn btn-outline-secondary" (click)="selectView('btnList')">
                <fa-icon [icon]="icons.faList"></fa-icon>
              </button>
              <button id="btnBloc" #btnBloc type="button" class="btn btn-outline-secondary" (click)="selectView('btnBloc')">
              <fa-icon [icon]="icons.faGrip"></fa-icon>
              </button>
            </!-->              
            <div class="d-inline-block">
              <!-- button class="btn btn-outline-secondary ms-2 border-2" > (click)="open()"
                <fa-icon [icon]="icons.faSliders" class="me-2"></fa-icon>
                Filtrar
              </button -->
            </div>
            <!-- button class="btn btn-dark ms-2" routerLink="create">
              <fa-icon [icon]="icons.faPlus"></fa-icon> Agregar 
            </!-->
          </div>
          <div class="form-group float-end me-3" style="width: 200px;">
            <div class="input-group">
              <!-- div class="input-group-addon border border-2 rounded-start-2 border-secondary border-end-0 ps-2 text-secondary" style="padding-top: 7px;">
                <fa-icon [icon]="icons.faSearch" ></fa-icon>
              </div -->
              <!-- input class="form-control border-2 border-secondary bg-transparent border-start-0" placeholder="Buscar" -->
              <!-- input id="typeahead-basic" type="text" class="form-control border-2 border-secondary bg-transparent border-start-0"  / -->
              <!-- [(ngModel)]="model" [ngbTypeahead]="searchx" -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
        <ul #sidebar app-nav-invoices [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
        <h4 class="mt-1 ms-3 mb-3" style="font-size: 1.2em">Reportes</h4>
        <ul class="list-unstyled">
          <li class="mb-3"><app-report-invoices-generic-canceled [profile]="profile"></app-report-invoices-generic-canceled></li>
        </ul>
      </div>

      <div #pages class="flex-fill">
        <div #dashboard id="dashboard" class="page d-flex flex-column">
          <!-- div>
            <div class="form-group">
              <label class="">Condominio</label>
              <select class="form-select form-select-lg bg-transparent" (change)="selectSettlement($event)">
                <option selected [value]="0">Selecciona un condominio</option>
                <option *ngFor="let settlement of settlements" [value]="settlement.id" [selected]="settlement.id == settlementId">{{settlement.name}}</option>
              </select>
            </div>
          </!-->
          <!-- div>
            <div class="form-group mt-3">
              <app-filter-advanced [toDate]="toDate" [fromDate]="fromDate" (dateRange)="updateDate($event)"></app-filter-advanced>
            </div>
            <button class="btn btn-primary rounded-3" (click)="searchBills()">
              <fa-icon [icon]="icons.faSearch"></fa-icon>
            </button>
          </!-->

          <div class="flex-fill">
            <div>
              <div class="list-group shadow">
                <div class="list-group-item">
                  <h3 class="mt-3">Recibos no emitidos</h3>
                  <table class="table mt-3">
                    <tr class="border-bottom">
                      <th>Sub-total</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.unpaid?.sub_total | currency}}</span></td>
                    </tr>
                    <tr class="border-bottom">
                      <th>I.V.A.</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.unpaid?.taxes | currency}}</span></td>
                    </tr>
                    <tr class="border-bottom">
                      <th>Total</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.unpaid?.total | currency}}</span></td>
                    </tr>
                  </table>
                </div>
                <div class="list-group-item">
                  <h3 class="mt-3">Recibos pendientes de pago</h3>
                  <table class="table mt-3">
                    <tr class="border-bottom">
                      <th>Sub-total</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.pending?.sub_total | currency}}</span></td>
                    </tr>
                    <tr class="border-bottom">
                      <th>I.V.A.</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.pending?.taxes | currency}}</span></td>
                    </tr>
                    <tr class="border-bottom">
                      <th>Total</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.pending?.total | currency}}</span></td>
                    </tr>
                  </table>
                </div>
                <div class="list-group-item">
                  <h3 class="mt-3">Recibos pagados</h3>
                  <table class="table mt-3">
                    <tr class="border-bottom">
                      <th>Sub-total</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.paid?.sub_total | currency}}</span></td>
                    </tr>
                    <tr class="border-bottom">
                      <th>I.V.A.</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.paid?.taxes | currency}}</span></td>
                    </tr>
                    <tr class="border-bottom">
                      <th>Total</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.paid?.total | currency}}</span></td>
                    </tr>
                  </table>
                </div>
                <div class="list-group-item">
                  <h2>Totales</h2>
                  <table class="table mt-3">
                    <tr class="border-bottom">
                      <th>Sub-total</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.totals?.sub_total | currency}}</span></td>
                    </tr>
                    <tr class="border-bottom">
                      <th>I.V.A.</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.totals?.taxes | currency}}</span></td>
                    </tr>
                    <tr class="border-bottom">
                      <th>Total</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.totals?.total | currency}}</span></td>
                    </tr>
                  </table>
                </div>
                <div class="list-group-item">
                  <h3 class="mt-3">Facturas pagadas</h3>
                  <table class="table mt-3">
                    <tr class="border-bottom">
                      <th>Sub-total</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.invoiced_paid?.sub_total | currency}}</span></td>
                    </tr>
                    <tr class="border-bottom">
                      <th>I.V.A.</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.invoiced_paid?.taxes | currency}}</span></td>
                    </tr>
                    <tr class="border-bottom">
                      <th>Total</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.invoiced_paid?.total | currency}}</span></td>
                    </tr>
                  </table>
                </div>
                <div class="list-group-item">
                  <h3 class="mt-3">Facturas no pagadas</h3>
                  <table class="table mt-3">
                    <tr class="border-bottom">
                      <th>Sub-total</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.invoiced_upaid?.sub_total | currency}}</span></td>
                    </tr>
                    <tr class="border-bottom">
                      <th>I.V.A.</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.invoiced_upaid?.taxes | currency}}</span></td>
                    </tr>
                    <tr class="border-bottom">
                      <th>Total</th>
                      <td class="text-end"><span *ngIf="loading"><fa-icon [icon]="icons.faCircleNotch" animation="spin"></fa-icon></span><span *ngIf="!loading">{{summary?.invoiced_upaid?.total | currency}}</span></td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div #invoices id="invoices" class="page d-none d-flex flex-column">
          <div class="d-flex">
            <div>
              <div ngbDropdown class="d-inline-block" (click)="datepicker.toggle()">
                <button type="button" class="btn btn-zazz-default rounded-4 px-4 shadow-sm" id="dropdownForm1" ngbDropdownToggle>
                  <fa-icon [icon]="icons.faCalendarAlt" class="me-2"></fa-icon>
                  Este mes
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownForm1" class="shadow" style="width: 650px;">
                  <div class="row">
                    <div class="col-3">
                      <ul class="list-group calendar-list-group ps-2 mt-2">
                        <li class="list-group-item list-group-item-action active">Hoy</li>
                        <li class="list-group-item list-group-item-action">Ayer</li>
                        <li class="list-group-item list-group-item-action">Este mes</li>
                        <li class="list-group-item list-group-item-action">Últimos 7 días</li>
                        <li class="list-group-item list-group-item-action">Últimos 30 días</li>
                        <li class="list-group-item list-group-item-action">Personalizado</li>
                      </ul>
                    </div>
                    <div class="col-9" style="height: 320px;">
                      <div class="input-group">
                        <input
                          #dpFromDate
                          class="form-control"
                          style="width: 0px !important; height: 0px !important; opacity: 0;"
                          ngbDatepicker
                          #datepicker="ngbDatepicker"
                          [autoClose]="'outside'"
                          (dateSelect)="onDateSelection($event)"
                          [displayMonths]="2"
                          [dayTemplate]="t"
                          outsideDays="hidden"
                          [startDate]="fromDate!"
                          tabindex="-1" 
                        />
                        <ng-template #t let-date let-focused="focused">
                          <span
                            class="custom-day"
                            [class.focused]="focused"
                            [class.range]="isRange(date)"
                            [class.faded]="isHovered(date) || isInside(date)"
                            (mouseenter)="hoveredDate = date"
                            (mouseleave)="hoveredDate = null"
                          >
                            {{ date.day }}
                          </span>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="dropdown-divider"></div>
                      <div class="d-flex text-end flex-fill flex-row-reverse me-2">
                        <button type="button" class="btn btn-zazz-dark ms-2 rounded-4 shadow-sm btn-sm px-4">Aplicar</button>     
                        <button type="button" class="btn btn-zazz-default rounded-4 shadow-sm btn-sm px-4">Cancelar</button>                      
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-fill">
            <!-- button class="btn btn-zazz-default rounded-4 px-4 ms-2 shadow-sm" (click)="openFilters()">
              <fa-icon [icon]="icons.faSliders" class="me-2"></fa-icon>
              Filtrar búsqueda
            </button -->
          </div>
          <div class="flex-fill ms-2">
            
          </div>
          </div>
          
          <div class="mt-4">
            <app-invoices ></app-invoices>
          </div>
        </div>
        <div #complement id="complement" class="page d-none d-flex flex-column">
          <div>
            <app-invoice-complement></app-invoice-complement>
          </div>
        </div>
        <div #global id="global" class="page d-none d-flex flex-column">
          <div>
            <app-invoice-global></app-invoice-global>
          </div>
        </div>
        <div #credit id="credit" class="page d-none d-flex flex-column">
          <div>
            <app-invoice-creditnote></app-invoice-creditnote>
          </div>
        </div>
        <div #canceled id="canceled" class="page d-none d-flex flex-column">
          <div>
            <app-invoice-canceled></app-invoice-canceled>
          </div>
        </div>
        <div #generic id="generic" class="page d-none d-flex flex-column">
          <div>
            <app-invoice-generic></app-invoice-generic>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class InvoiceDashboardComponent implements OnInit {
  profile: any = {};
  permissions: any = {};
  loading: boolean = false;

  payFilterPrefs: any = {};

  currentView: string = 'dashboard';

  hoveredDate: NgbDate | null = null;

  @ViewChild('sidebar') sidebar !: ElementRef;
  @ViewChild('pages') pages !: ElementRef;

  summary: any = {};

  timbreChart: any[] = [];
  status: any = [
    {
      name: 'timbresUtilizados',
      value: 0
    },
    {
      name: 'creditosRestantes',
      value: 0
    },
  ];

  a = new Date();
  fromDate; // : any = "2023/12/01"; // Date = new Date();
  toDate; // : any = "2024/02/02"; // Date = new Date();

  settlementId: any = 0;
  settlement: any = {};
  settlements: any = [];

  payload: any = {
    created_at_since: '',
    created_at_to: '',
    profile_id: '',
  };
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    public icons: IconsService,
    private offcanvasService: NgbOffcanvas,
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS);

    if (this.a.getMonth() == 0) {
      this.fromDate = new NgbDate(this.a.getFullYear() -1, 12, 1);
    } else {
      this.fromDate = new NgbDate(this.a.getFullYear(), this.a.getMonth(), 1);
    }
    const day = 
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastMonthDay(this.a.getFullYear(), this.a.getMonth(), 29));

    this.payload.created_at_since = `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`;
    this.payload.created_at_to = `${this.toDate.year}-${this.toDate.month}-${this.toDate.day}`;
    this.payload.profile_id = this.profile.id;
  }

  ngOnInit(): void {
    let timbres = document.getElementById('timbres');
    this.timbreChart = [Number(timbres?.offsetWidth), 200];
    this.loadStatus();
    this.loadProfile();
    this.loadBillsPaidSummary(this.payload);
    this.loadSettlement(this.settlementId);
    this.loadSettlements();
  }

  updateDate(event: any) {
    this.fromDate = event.from;
    this.toDate = event.to;
    console.log('DATE RANGE ====> ', this.fromDate, this.toDate);
  }

  searchBills() {
    this.payload.created_at_since = `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`;
    this.payload.created_at_to = `${this.toDate.year}-${this.toDate.month}-${this.toDate.day}`;
    this.loadBillsPaidSummary(this.payload);
  }

  loadStatus() {
    this.store.getInvoiceStatus(this.profile.id).subscribe((status: any) => {
      console.log("status account ===> ", status);
      if (!status) return;
      this.status[0].value = status.timbresUtilizados;
      this.status[1].value = status.creditosRestantes;
    });

    console.log("status account ===> ", this.status);
  }

  selectSettlement(e: any) {
    this.settlementId = e.target.value;
    this.loadBillsPaidSummary(this.payload);
    this.loadSettlement(this.settlementId);
  }

  loadSettlements() {
    this.store.getSettlements({
      per_page: 1000,
      page: 1,
      utility_id: this.profile.utility_id
    }).subscribe((stls: any) => {
      this.settlements = stls.data;
    });
  }

  loadSettlement(id: any) {
    if (id == 0) return;
    this.store.getSettlement(id).subscribe((stl: any) => {
      this.settlement = stl;
    });
  }

  loadProfile() {
    this.store.getProfile(this.profile.id).subscribe((profile: any) => {
      this.profile = profile;
    });
  }

  loadBillsPaidSummary(payload: any) {
    this.loading = true;
    

    if (this.settlementId != 0) {
      payload.settlement_id = this.settlementId;
    }

    this.store.getBillsByUtilitySummary(payload).subscribe((summary: any) => {
      this.summary = summary;
      this.loading = false;
    });
  }

  

  onDateSelection(date: NgbDate) {
    console.log("date ====> ", date);
		if (!this.fromDate && !this.toDate) {
			this.fromDate = date;
		} else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
			this.toDate = date;
		} else {
			// this.toDate = null;
			this.fromDate = date;
		}

    // this.router.navigate([], {
      // relativeTo: this.route,
      // queryParams: { 
        // "created_at_since": `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`, 
        // "created_at_to": `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}`
      // },
      // queryParamsHandling: 'merge'
    // });

    // this.dateRange.emit({from: this.fromDate, to: this.toDate});
	}

  openFilters() {
      const offcanvasRef = this.offcanvasService.open(FullFilterComponent, {
        position: 'end',
        animation: true,
        backdrop: true,
        keyboard: true,
        scroll: true,
        backdropClass: 'bg-dark',
        panelClass: 'bg-light',
      });
  
      offcanvasRef.componentInstance.payload = this.payFilterPrefs;
      offcanvasRef.componentInstance.profile = this.profile;
      offcanvasRef.result.then((result: any) => {
        console.log('result => ', result);
        // this.payFilterPrefs = result;
        // this.loadBills(this.payFilterPrefs);
      });
    }

	isHovered(date: NgbDate) {
    return this.fromDate;
		// return (
			// this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
		// );
	}

	isInside(date: NgbDate) {
		return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
	}

	isRange(date: NgbDate) {
		return (
			date.equals(this.fromDate) ||
			(this.toDate && date.equals(this.toDate)) ||
			this.isInside(date) ||
			this.isHovered(date)
		);
	}

}
